const sliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-list, .js-media-list-mobile") &&
    document.querySelectorAll(".js-media-list, .js-media-list-mobile").length >
      0
  ) {
    document
      .querySelectorAll(".js-media-list, .js-media-list-mobile")
      .forEach((elem, index) => {
        let prevButton = elem.querySelector(
          ".product__slider-nav .swiper-button-prev"
        );
        let nextButton = elem.querySelector(
          ".product__slider-nav .swiper-button-next"
        );
        let pagination = elem.querySelector(".product__pagination");
        const initialSlide = elem.dataset.currentIndex || 0;

        if (elem.swiper) {
          elem.swiper.destroy(true, true);
        }

        let slider = new Swiper(elem, {
          initialSlide: initialSlide,
          slidesPerView:
            elem
              .closest(".product__outer")
              .classList.contains("product__gallery--full_screen_top-mobile") ||
            elem
              .closest(".product__outer")
              .classList.contains("product__gallery--single_aside-mobile") ||
            elem
              .closest(".product__outer")
              .classList.contains("product__gallery--thumbs_aside-mobile")
              ? 1
              : 1.1,
          spaceBetween: elem
            .closest(".product__outer")
            .classList.contains("product__gallery--multiple_top-mobile")
            ? 0
            : 1,
          autoHeight: elem.classList.contains("product__media-list--auto-enabled"),
          speed: 500,
          freeMode: {
            enabled:
              window.innerWidth < 750
                ? elem
                    .closest(".product__outer")
                    .classList.contains("product__gallery--multiple_top-mobile")
                : elem
                    .closest(".product__outer")
                    .classList.contains("product__outer--multiple-top"),
            sticky: true,
          },
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: {
            el: pagination,
            type: "bullets",
            clickable: true,
          },
          thumbs: {
            swiper: elem.nextElementSibling.querySelector(".js-media-sublist")
              ?.swiper
              ? elem.nextElementSibling.querySelector(".js-media-sublist")
                  .swiper
              : "",
          },
          breakpoints: {
            750: {
              slidesPerView:
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--full-screen") ||
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--single-aside") ||
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--thumbs-aside")
                  ? 1
                  : 1.1,
              spaceBetween: elem
                .closest(".product__outer")
                .classList.contains("product__outer--multiple-top")
                ? 0
                : 1,
            },
            // Fixed
            990: {
              slidesPerView:
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--full-screen") ||
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--single-aside") ||
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--thumbs-aside")
                  ? 1
                  : 2.37,
            },
          },
          on: {
            afterInit: function (swiper) {
              if (
                (document.querySelector(".product__outer--multiple-top") &&
                  window.innerWidth >= 750) ||
                (document.querySelector(
                  ".product__gallery--multiple_top-mobile"
                ) &&
                  window.innerWidth < 750)
              ) {
                document
                  .querySelectorAll(".product__media-toggle")
                  .forEach((elem, index) => {
                    elem.addEventListener("click", (e) => {
                      var target = e.currentTarget;

                      if (
                        document.querySelector(".js-popup-slider") &&
                        document.querySelector(".js-popup-slider").swiper
                      ) {
                        document
                          .querySelector(".js-popup-slider")
                          .swiper.slideTo(index);
                      }
                    });
                  });
              }
            },
            slideChangeTransitionStart: function () {
              const slider =
                document.querySelector(".js-media-list") ||
                document.querySelector(".js-media-list-mobile");
              if (
                document.querySelector(".js-media-sublist") &&
                document.querySelector(".js-media-sublist").swiper
              ) {
                document
                  .querySelector(".js-media-sublist")
                  .swiper.slideTo(slider.swiper.activeIndex);
              }
            },
            slideChange: function () {
              window.pauseAllMedia();
              this.params.noSwiping = false;

              if (
                document.querySelector(".js-popup-slider") &&
                document.querySelector(".js-popup-slider").swiper &&
                !(
                  (document.querySelector(".product__outer--multiple-top") &&
                    window.innerWidth >= 750) ||
                  (document.querySelector(
                    ".product__gallery--multiple_top-mobile"
                  ) &&
                    window.innerWidth < 750)
                )
              ) {
                document
                  .querySelector(".js-popup-slider")
                  .swiper.slideTo(this.activeIndex);
              }
            },
            slideChangeTransitionEnd: function () {
              if (this.slides[this.activeIndex].querySelector("model-viewer")) {
                this.slides[this.activeIndex]
                  .querySelector(".shopify-model-viewer-ui__button--poster")
                  .removeAttribute("hidden");
              }
            },
            touchStart: function () {
              if (this.slides[this.activeIndex].querySelector("model-viewer")) {
                if (
                  !this.slides[this.activeIndex]
                    .querySelector("model-viewer")
                    .classList.contains("shopify-model-viewer-ui__disabled")
                ) {
                  this.params.noSwiping = true;
                  this.params.noSwipingClass = "swiper-slide";
                } else {
                  this.params.noSwiping = false;
                }
              }
            },
          },
        });

        if (isUpdate) {
          setTimeout(function () {
            slider.update();
          }, 800);
        }
      });

    const pageResizeObserve = new ResizeObserver((entries) => {
      const [entry] = entries;

      if (entry.contentRect.width < 750) {
        const slider = entry.target.querySelector(".js-media-list");
        const sliderMobile = entry.target.querySelector(
          ".js-media-list-mobile"
        );

        if (
          slider &&
          slider.swiper &&
          (entry.target.querySelector(
            ".product__gallery--static_multicolumns_aside-mobile"
          ) ||
            entry.target.querySelector(
              ".product__gallery--static_column_aside-mobile"
            ))
        ) {
          slider.swiper.destroy(true, true);
        }

        if (sliderMobile && !slider) {
          if (!sliderMobile.swiper) {
            subSliderInit(true);
            sliderInit(true);
            popupSliderInit(true);
          }
        }
      } else {
        const slider = entry.target.querySelector(".js-media-list");
        const sliderMobile = entry.target.querySelector(
          ".js-media-list-mobile"
        );

        if (sliderMobile && sliderMobile.swiper && !slider) {
          sliderMobile.swiper.destroy(true, true);
        }

        if (slider) {
          if (!slider.swiper) {
            subSliderInit(true);
            sliderInit(true);
            popupSliderInit(true);
          }
        }
      }
    });

    if (document.querySelector(".product-section"))
      pageResizeObserve.observe(document.querySelector(".product-section"));
  }
};

const subSliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-sublist") &&
    document.querySelectorAll(".js-media-sublist").length > 0
  ) {
    document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {
      if (elem.swiper) elem.swiper.destroy();
      const isThumbsAside = elem.classList.contains("sublist-thumbs-aside");

      const breakpoint = isThumbsAside ? 1100 : 990;

      let subSlider = new Swiper(elem, {
        slidesPerView: 4,
        spaceBetween: 8,
        direction: "horizontal",
        direction: "horizontal",
        freeMode: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        autoHeight: true,
        on: {
          afterInit: function () {
            //this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
          },
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        //transitionStart: function () {
        //	document
        //		.querySelector(".js-media-list")
        //		.swiper.slideTo(
        //			document.querySelector(".js-media-sublist").swiper.activeIndex,
        //		);
        //},
        breakpoints: {
          [breakpoint]: {
            spaceBetween: 4,
            direction: "vertical",
            slidesPerView: "auto",
            direction: "vertical",
            slidesPerView: "auto",
          },
        },
      });

      const sliderResizeObserve = new ResizeObserver((entries) => {
        const [entry] = entries;
        // Fixed
        if (entry.contentRect.width >= breakpoint) {
          setTimeout(() => {
            const sliders = document.querySelectorAll(
              ".js-media-list, .js-media-list-mobile"
            );
            const thumbs = document.querySelectorAll(".product__media-sublist");

            const sliderHeight = sliders[index].getBoundingClientRect().height;
            thumbs[index].style.height = `${sliderHeight - 1}px`;
          }, 400);
        }
      });

      if (document.querySelector(".product-section"))
        sliderResizeObserve.observe(document.querySelector(".product-section"));
      if (document.querySelector(".product-section"))
        sliderResizeObserve.observe(document.querySelector(".product-section"));

      document
        .querySelectorAll(".featured-product-section")
        .forEach((section) => {
          sliderResizeObserve.observe(section);
        });

      if (isUpdate) {
        setTimeout(function () {
          subSlider.update();
        }, 800);
      }
    });
  }
};

const popupSliderInit = (isUpdate) => {
  if (document.querySelector(".js-popup-slider")) {
    let popupSlider = new Swiper(document.querySelector(".js-popup-slider"), {
      slidesPerView: 1,
      navigation: {
        nextEl: ".product-media-modal .product__slider-nav .swiper-button-next",
        prevEl: ".product-media-modal .product__slider-nav .swiper-button-prev",
      },
      pagination: {
        el: ".product-media-modal .product__pagination",
        type: "bullets",
        clickable: true,
      },
      on: {
        afterInit: function () {
          if (
            document.querySelector(
              ".product__outer--static-multicolumns-aside"
            ) ||
            document.querySelector(".product__outer--static-column-aside") ||
            document.querySelector(
              ".product__gallery--static_multicolumns_aside-mobile"
            ) ||
            document.querySelector(
              ".product__gallery--static_column_aside-mobile"
            )
          ) {
            document
              .querySelectorAll(".product__media-list .product__media-toggle")
              .forEach((elem, index) => {
                elem.addEventListener("click", (e) => {
                  if (
                    document.querySelector(".js-popup-slider") &&
                    document.querySelector(".js-popup-slider").swiper
                  ) {
                    document
                      .querySelector(".js-popup-slider")
                      .swiper.slideTo(index);
                  }
                });
              });
          }
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          document
            .querySelector(".product-media-modal__content")
            .classList.remove("zoom");
        },
        touchMove: function () {
          document
            .querySelector(".product-media-modal__content")
            .classList.remove("zoom");
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            this.slides[this.activeIndex]
              .querySelector(".shopify-model-viewer-ui__button--poster")
              .removeAttribute("hidden");
          }
        },
        touchStart: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if (
              !this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });

    if (isUpdate) {
      setTimeout(function () {
        popupSlider.update();
      }, 800);
    }
  }
};

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

(function () {
  const headerDrawer = document.querySelector("header-drawer");
  if (!headerDrawer) return;

  const drawerTabs = document.querySelectorAll(".mega-menu__tab");
  if (!drawerTabs) return;

  drawerTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tab.classList.toggle("tab--active");
      const tabToggler = tab.querySelector(".mega-menu__tab-toggler");
      const initialExpanded = JSON.parse(
        tabToggler.getAttribute("aria-expanded")
      );
      tabToggler.setAttribute("aria-expanded", `${!initialExpanded}`);
    });
  });
})();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
    elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.buttonMinus = this.querySelector('button[name="minus"]');
    this.buttonPlus = this.querySelector('button[name="plus"]');
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    this.updateButtonStates();

    var eventList = ["paste", "input"];

    for (const eventName of eventList) {
      this.input.addEventListener(eventName, (event) => {
        const numberRegex = /^\d*$/;

        if (!numberRegex.test(event.currentTarget.value)) {
          event.currentTarget.value = this.getMinimumValue();
        }

        this.updateButtonStates();
      });
    }

    this.input.addEventListener("change", () => this.updateButtonStates());

    this.input.addEventListener("focusout", (event) => {
      if (event.currentTarget.value === "") {
        event.currentTarget.value = this.getMinimumValue();
      }

      this.updateButtonStates();
    });
  }

  getMinimumValue() {
    const parsedMinimum = parseInt(
      this.input.getAttribute("min") ?? this.input.dataset.min,
      10
    );

    return Number.isNaN(parsedMinimum) ? 1 : parsedMinimum;
  }

  getMaximumValue() {
    const parsedMaximum = parseInt(
      this.input.getAttribute("max") ?? this.input.dataset.max,
      10
    );

    return Number.isNaN(parsedMaximum) ? null : parsedMaximum;
  }

  updateButtonStates() {
    const minimumValue = this.getMinimumValue();
    const maximumValue = this.getMaximumValue();
    const currentValue = parseInt(this.input.value, 10);
    const isEmpty = this.input.value === "" || Number.isNaN(currentValue);

    if (this.buttonMinus) {
      this.buttonMinus.disabled = isEmpty || currentValue <= minimumValue;
    }

    if (this.buttonPlus) {
      this.buttonPlus.disabled =
        !isEmpty && maximumValue !== null && currentValue >= maximumValue;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.updateButtonStates();
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".toggle-scheme-button") === button) return;
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      this.header =
        this.header || document.querySelector(".shopify-section-header");
      const main = document.querySelector("main");
      if (
        main
          .querySelectorAll(".shopify-section")[0]
          ?.classList.contains("section--has-overlay") &&
        !this.header.classList.contains("animate")
      ) {
        this.header.classList.add("color-background-1", "color-background-3");
      }
      if (
        this.header.classList.contains("color-background-1") &&
        !this.header.classList.contains("shopify-section-header-sticky")
      ) {
        this.header.classList.add("color-background-3");
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute("open")) return;

      const ae = document.activeElement;

      if (this.mainDetailsToggle.contains(ae)) return;

      const root = ae?.getRootNode?.();
      if (
        root instanceof ShadowRoot &&
        this.mainDetailsToggle.contains(root.host)
      )
        return;

      if (ae?.closest?.("dialog")) return;

      if (!ae || ae === document.body || ae === document.documentElement)
        return;

      if (this.classList.contains("mobile-facets__wrapper"))
        this.closeMenuDrawer();
      else this.closeMenuDrawer(event);
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    if (
      this.header.classList.contains("color-background-3") &&
      !this.header.classList.contains("shopify-section-header-sticky")
    ) {
      this.header.classList.remove("color-background-3");
    }

    const main = document.querySelector("main");
    if (
      main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("section--has-overlay")
    ) {
      this.header.classList.remove("color-background-3");
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }

    const images = document.querySelector(".product-media-modal__content");

    if (images) {
      images.classList.remove("zoom");
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();

      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
              this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
  }

  getBaseSectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }

  isQuickViewContext() {
    return !!this.closest("quick-add-modal");
  }

  getDestinationSectionId() {
    return this.isQuickViewContext()
      ? this.dataset.section
      : this.getBaseSectionId();
  }

  getProductSectionRoot() {
    return this.closest(
      ".product-section, .featured-product-section, .quick-add-modal__content-wrapper"
    );
  }

  getLinkedVariantPickers() {
    const productSectionRoot = this.getProductSectionRoot();
    const baseSectionId = this.getBaseSectionId();

    if (!productSectionRoot || !baseSectionId) {
      return [this];
    }

    return Array.from(
      productSectionRoot.querySelectorAll("variant-selects, variant-radios")
    ).filter((picker) => {
      return (
        (picker.dataset.originalSection || picker.dataset.section) ===
        baseSectionId
      );
    });
  }

  getLinkedSectionIds() {
    return [
      ...new Set(
        this.getLinkedVariantPickers().map((picker) => picker.dataset.section)
      ),
    ];
  }

  scopeMarkupToSection(markup, targetSectionId, sourceSectionId) {
    if (!markup) return markup;

    if (targetSectionId === sourceSectionId) {
      return markup;
    }

    return markup.replaceAll(sourceSectionId, targetSectionId);
  }

  getVariantImageSwatchKey(fieldset, wrapper) {
    if (!fieldset || !wrapper) return null;

    const label = wrapper.querySelector("label.variant-swatch.image-swatch");
    if (!label) return null;

    const computedBackground = window.getComputedStyle(label).backgroundImage;
    const inlineStyle = label.getAttribute("style") || "";
    const source =
      computedBackground && computedBackground !== "none"
        ? computedBackground
        : inlineStyle;

    const bgMatch = source.match(/url\((['"]?)(.*?)\1\)/i);
    const imageKey = (bgMatch?.[2] || "").trim();

    if (!imageKey || imageKey.startsWith("data:image")) return null;

    return imageKey;
  }

  removeDuplicateImageSwatches(scopeEl = this) {
    if (!scopeEl) return;

    const fieldsets = scopeEl.querySelectorAll(
      '[data-is-variant-image-swatch="true"]'
    );

    fieldsets.forEach((fieldset) => {
      const seen = new Map();
      const wrappers = fieldset.querySelectorAll(".variant-swatch-wrapper");

      wrappers.forEach((wrapper) => {
        const key = this.getVariantImageSwatchKey(fieldset, wrapper);
        if (!key) return;

        const label = wrapper.querySelector(
          "label.variant-swatch.image-swatch"
        );
        const inputId = label?.getAttribute("for");
        const input = inputId
          ? document.getElementById(inputId)
          : wrapper.previousElementSibling?.matches('input[type="radio"]')
          ? wrapper.previousElementSibling
          : null;

        if (!seen.has(key)) {
          seen.set(key, input || null);
          return;
        }

        const primaryInput = seen.get(key);

        if (input?.checked && primaryInput && !primaryInput.checked) {
          primaryInput.checked = true;
          primaryInput.setAttribute("checked", "");
        }

        input?.remove();
        wrapper.remove();
      });
    });
  }

  syncPickerStateFromHtml(targetPicker, html) {
    if (!targetPicker || !html) return;

    const sourceSectionId = this.getBaseSectionId();
    const targetSectionId = targetPicker.dataset.section;
    const sourceVariantPicker = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );

    if (!sourceVariantPicker || !targetSectionId) return;

    if (sourceVariantPicker.dataset.url) {
      targetPicker.dataset.url = sourceVariantPicker.dataset.url;
    }

    if (sourceVariantPicker.dataset.isHighVariantProduct) {
      targetPicker.dataset.isHighVariantProduct =
        sourceVariantPicker.dataset.isHighVariantProduct;
    }

    targetPicker.variantData = null;

    const sourceScriptNoHigh = sourceVariantPicker.querySelector(
      "[data-all-variants-no-high]"
    );
    const destScriptNoHigh = targetPicker.querySelector(
      "[data-all-variants-no-high]"
    );
    if (sourceScriptNoHigh && destScriptNoHigh) {
      destScriptNoHigh.textContent = sourceScriptNoHigh.textContent;
    }

    const sourceScriptSelected = sourceVariantPicker.querySelector(
      "[data-selected-variant]"
    );
    const destScriptSelected = targetPicker.querySelector(
      "[data-selected-variant]"
    );
    if (sourceScriptSelected && destScriptSelected) {
      destScriptSelected.textContent = sourceScriptSelected.textContent;

      try {
        targetPicker.currentVariant = sourceScriptSelected.textContent
          ? JSON.parse(sourceScriptSelected.textContent)
          : null;
      } catch (e) {
        targetPicker.currentVariant = null;
      }
    }

    const sourceFieldsets = sourceVariantPicker.querySelectorAll("fieldset");
    const destFieldsets = targetPicker.querySelectorAll("fieldset");

    if (sourceFieldsets.length > 0 && destFieldsets.length > 0) {
      sourceFieldsets.forEach((sourceFieldset, index) => {
        if (!destFieldsets[index]) return;

        destFieldsets[index].removeAttribute("data-initialized");
        destFieldsets[index].innerHTML = this.scopeMarkupToSection(
          sourceFieldset.innerHTML,
          targetSectionId,
          sourceSectionId
        );

        if (sourceFieldset.className) {
          destFieldsets[index].className = sourceFieldset.className;
        }
      });
    } else {
      targetPicker.innerHTML = this.scopeMarkupToSection(
        sourceVariantPicker.innerHTML,
        targetSectionId,
        sourceSectionId
      );
    }
  }

  syncLinkedVariantPickers(html) {
    this.getLinkedVariantPickers().forEach((picker) => {
      if (picker === this) return;

      this.syncPickerStateFromHtml(picker, html);
      if (typeof picker.removeDuplicateImageSwatches === "function") {
        picker.removeDuplicateImageSwatches();
      }
    });
  }

  connectedCallback() {
    window.requestAnimationFrame(() => {
      this.removeDuplicateImageSwatches();
    });
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    const clickedElement =
      event.target.closest("[data-product-url]") || event.target;
    this.combinedProductURL = clickedElement.dataset?.productUrl || null;

    const combinedProductURL = event.target.dataset?.productUrl;

    this.updateOptions();
    // updateMasterId method updates currentVariant from liquid <script data-all-variations-no-high>
    this.updateMasterId();
    this.toggleAddButton(true, "");

    this.isHighVariantNeedUpdate = false;
    // -----
    // checking for high-variant and combined products
    // if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }
    // -----

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (
        this.currentVariant?.featured_media &&
        this.dataset?.variantMediaDisplay === "show_all"
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        const mediaId = `${this.getBaseSectionId()}-${
          this.currentVariant.featured_media.id
        }`;
        this.updateMedia(mediaId);
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia(mediaId) {
    if (!mediaId) return;

    const baseSectionId = this.getBaseSectionId();
    const destinationSectionId = this.getDestinationSectionId();
    const productSectionRoot = this.getProductSectionRoot();
    const isQuickView = this.isQuickViewContext();

    const mediaEl =
      productSectionRoot?.querySelector(
        `[data-section="product-media-${destinationSectionId}"]`
      ) ||
      (!isQuickView
        ? document.querySelector(
            `[data-section="product-media-${baseSectionId}"]`
          )
        : null);
    if (!mediaEl) return;

    // for slider and slider_previews layout
    const sliderEl = mediaEl.querySelector(".js-media-list");
    if (sliderEl && sliderEl.swiper) {
      sliderEl.querySelectorAll(".swiper-slide").forEach((slide, index) => {
        const slideMediaId = slide.dataset?.mediaId;
        if (slideMediaId === mediaId) {
          const findIndex = sliderEl.swiper.slides.findIndex((slideEl) => {
            return slideEl.dataset?.mediaId === slideMediaId;
          });
          const fallbackIndex = Number(
            slide.dataset?.swiperSlideIndex || index
          );
          const swiperSlideIndex = findIndex !== -1 ? findIndex : fallbackIndex;
          sliderEl.swiper.slideTo(swiperSlideIndex, 800);
        }
      });
    }

    // for stacked layouts (static multicolumn/column on desktop)
    const isDesktopStackedGallery =
      window.innerWidth >= 990 &&
      mediaEl
        .closest(".product__outer")
        ?.matches(
          ".product__outer--static-multicolumns-aside, .product__outer--static-column-aside"
        );

    if (isDesktopStackedGallery) {
      const stackedItems = mediaEl.querySelectorAll(
        ".product__media-item[data-media-id]"
      );

      stackedItems.forEach((mediaItem) => {
        mediaItem.classList.toggle(
          "active",
          mediaItem.dataset?.mediaId === mediaId
        );
      });

      const activeStackedItem = Array.from(stackedItems).find((mediaItem) => {
        return mediaItem.dataset?.mediaId === mediaId;
      });

      if (activeStackedItem) {
        const offset =
          activeStackedItem.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: offset - 100, behavior: "smooth" });
      }
    }
  }

  updateURL() {
    if (!this.closest(".quick-add-modal__content-wrapper")) {
      if (this.dataset.updateUrl === "false") return;
      let basePath =
        this.combinedProductURL || this.dataset.url || window.location.pathname;

      if (basePath.includes("?")) {
        basePath = basePath.split("?")[0];
      }

      const newUrl = this.currentVariant
        ? `${basePath}?variant=${this.currentVariant.id}`
        : basePath;

      window.history.replaceState({}, "", newUrl);
    }
  }

  updateVariantInput() {
    const productSectionRoot = this.getProductSectionRoot() || document;
    const selectors = this.getLinkedSectionIds()
      .flatMap((sectionId) => {
        return [
          `#product-form-${sectionId}`,
          `#product-form-installment-${sectionId}`,
        ];
      })
      .join(", ");

    const productForms = selectors
      ? productSectionRoot.querySelectorAll(selectors)
      : [];

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.getBaseSectionId(),
        variant: this.currentVariant,
      },
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant.options[index - 1] === previousOptionSelected
        )
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];

    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;

      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];

      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }

  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    const selectedValues = controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    });

    return selectedValues;
  }

  updatePickupAvailability() {
    const pickUpAvailability = this.getProductSectionRoot()?.querySelector(
      "pickup-availability"
    );
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (
                this.currentVariant.featured_media &&
                this.dataset?.variantMediaDisplay === "show_all"
              ) {
                // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
                const mediaId = `${this.getBaseSectionId()}-${
                  this.currentVariant.featured_media.id
                }`;
                this.updateMedia(mediaId);
              }
            }
          } catch (err) {}
        }
        // -----

        this.updateElementsAfterFetch(html);
        this.syncLinkedVariantPickers(html);

        if (this.currentVariant?.featured_media) {
          const mediaId = `${this.getBaseSectionId()}-${
            this.currentVariant.featured_media.id
          }`;
          this.updateMedia(mediaId);
        }

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  toggleAddButton(disable = true, text) {
    const productSectionRoot = this.getProductSectionRoot() || document;
    const selectors = this.getLinkedSectionIds()
      .flatMap((sectionId) => {
        return [
          `#product-form-${sectionId}`,
          `#product-form-installment-${sectionId}`,
        ];
      })
      .join(", ");

    const productForms = selectors
      ? productSectionRoot.querySelectorAll(selectors)
      : [];

    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const addButtonText =
        addButton.querySelector(".button__label") ||
        addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        if (text) {
          addButtonText.textContent = text;

          if (text === window.variantStrings.unavailable) {
            addButton.dataset.status = "unavailable";
          } else {
            addButton.dataset.status = "sold-out";
          }
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
        addButton.dataset.status = "available";
      }
    });
  }

  resetErrorMessage() {
    const productSectionRoot = this.getProductSectionRoot() || document;
    const selectors = this.getLinkedSectionIds()
      .flatMap((sectionId) => {
        return [
          `#product-form-${sectionId}`,
          `#product-form-installment-${sectionId}`,
        ];
      })
      .join(", ");

    const productForms = selectors
      ? productSectionRoot.querySelectorAll(selectors)
      : [];

    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  setUnavailable() {
    const baseSectionId = this.getBaseSectionId();

    const price = document.getElementById(`price-${baseSectionId}`);
    const priceSticky = document.getElementById(
      `price-sticky-${baseSectionId}`
    );
    const inventory = document.getElementById(`Inventory-${baseSectionId}`);
    const pickerInventory = document.getElementById(
      `PickerInventory-${baseSectionId}`
    );
    const sku = document.getElementById(`Sku-${baseSectionId}`);
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${baseSectionId}"]`
    );

    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (pickerInventory) pickerInventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-all-variants-no-high]").textContent);
    return this.variantData;
  }

  reinitModalSwiper(modalElement) {
    if (!modalElement) return;

    // 1. Locate the correct container frame housing the zoom slider markup
    const swiperContainer =
      modalElement.querySelector("#product-page-swiper") ||
      modalElement.querySelector(".swiper");
    if (!swiperContainer) return;

    // 2. FORCE KILL GHOST INSTANCES: Deep destroy the old swiper state machine to free up event binds
    if (swiperContainer.swiper) {
      try {
        swiperContainer.swiper.destroy(true, true);
      } catch (e) {
        console.warn("Swiper destruction error managed gracefully:", e);
      }
      delete swiperContainer.swiper;
    }

    // 3. HARD REBUILD FROM SCRATCH: Force initialize the Zoom parameters explicitly
    if (typeof Swiper !== "undefined") {
      const nextBtn =
        modalElement.querySelector(".swiper-button-next-prod-page") ||
        modalElement.querySelector(".swiper-button-next");
      const prevBtn =
        modalElement.querySelector(".swiper-button-prev-prod-page") ||
        modalElement.querySelector(".swiper-button-prev");
      const paginationEl =
        modalElement.querySelector(".swiper-pagination-product-page") ||
        modalElement.querySelector(".swiper-pagination");

      const config = {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true, // Instructs browser to render standard grab system cursors
        allowTouchMove: true, // Restores standard swipe navigation behavior
        observer: true, // Recalculates if internal elements mutate
        observeParents: true,

        // CRITICAL ZOOM DECLARATIONS: Unlocks secondary deep-zoom functionalities safely
        zoom: {
          maxRatio: 3,
          minRatio: 1,
          toggle: true, // Restores double-tap / double-click inner modal zooming
          containerClass: "swiper-zoom-container",
          zoomedSlideClass: "swiper-slide-zoomed",
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      };

      // Inject explicit Swiper layout modules if theme layout demands it
      if (Swiper.modules) {
        config.modules = [
          Swiper.modules.Navigation,
          Swiper.modules.Pagination,
          Swiper.modules.Zoom,
        ].filter(Boolean);
      }

      // Initialize the fresh layout lifecycle instance
      const cleanInstance = new Swiper(swiperContainer, config);

      // 4. THE OVERRIDE: Programmatically handle fallback zoom mechanics if the core module fails
      cleanInstance.on("zoomChange", (swiper, scale, imageEl, slideEl) => {
        if (scale > 1) {
          slideEl.classList.add("swiper-slide-zoomed");
          if (imageEl) imageEl.style.cursor = "zoom-out";
        } else {
          slideEl.classList.remove("swiper-slide-zoomed");
          if (imageEl) imageEl.style.cursor = "zoom-in";
        }
      });

      // Force sync the layout engine boundaries on the next rendering pass
      window.requestAnimationFrame(() => {
        cleanInstance.update();
      });
    }

    // 5. HARD RECOVERY FOR INNER CURSOR TRACKING STATE
    window.setTimeout(() => {
      const imagesAndSlides = modalElement.querySelectorAll(
        "img, .swiper-slide, .swiper-zoom-container"
      );
      imagesAndSlides.forEach((el) => {
        // Direct assignment overrides stuck custom cursor canvas targets completely
        el.removeAttribute("disabled");
        el.style.setProperty("cursor", "zoom-in", "important");
        el.style.setProperty("pointer-events", "auto", "important");
      });

      // Keep primary navigation controls safely accessible above image boundaries
      const layoutControls = modalElement.querySelectorAll(
        ".swiper-button-next, .swiper-button-prev, .swiper-pagination, .swiper-pagination-bullet, button"
      );
      layoutControls.forEach((control) => {
        control.style.setProperty("cursor", "pointer", "important");
        control.style.setProperty("pointer-events", "auto", "important");
        control.style.setProperty("z-index", "99", "important");
      });
    }, 150);
  }

  updateElementsAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const baseSectionId = this.getBaseSectionId();
    const destinationSectionId = this.getDestinationSectionId();
    const isQuickView = this.isQuickViewContext();
    const productSectionRoot = this.getProductSectionRoot();

    // =================================================================
    // 1. UPDATE BASE URL & CLEAR CACHED STATE OBJECTS
    // =================================================================
    const sourceVariantPicker = html.querySelector(
      "variant-selects, variant-radios"
    );
    if (sourceVariantPicker) {
      if (sourceVariantPicker.dataset.url) {
        this.dataset.url = sourceVariantPicker.dataset.url;
      }
      if (sourceVariantPicker.dataset.isHighVariantProduct) {
        this.dataset.isHighVariantProduct =
          sourceVariantPicker.dataset.isHighVariantProduct;
      }
    }

    // Purge the master array cache so it's forced to look at the new product JSON
    this.variantData = null;

    // =================================================================
    // 2. SYNCHRONIZE HIDDEN VARIANT JSON MARKUP POOLS & FIX VISIBILITY BUG
    // =================================================================
    const sourceScriptNoHigh = html.querySelector(
      "[data-all-variants-no-high]"
    );
    const destScriptNoHigh = this.querySelector("[data-all-variants-no-high]");
    if (sourceScriptNoHigh && destScriptNoHigh) {
      destScriptNoHigh.textContent = sourceScriptNoHigh.textContent;
    }

    const sourceScriptSelected = html.querySelector("[data-selected-variant]");
    const destScriptSelected = this.querySelector("[data-selected-variant]");
    if (sourceScriptSelected && destScriptSelected) {
      destScriptSelected.textContent = sourceScriptSelected.textContent;

      // FIXES THE 'visibility-hidden' BUG:
      // Instantly inject the correct selected variant object into the component state
      try {
        this.currentVariant = JSON.parse(sourceScriptSelected.textContent);
      } catch (e) {
        this.currentVariant = null;
      }
    }

    // =================================================================
    // 3. OVERWRITE INPUT CONTROLS MARKUP COMPLETELY
    // =================================================================
    if (sourceVariantPicker) {
      const sourceFieldsets = sourceVariantPicker.querySelectorAll("fieldset");
      const destFieldsets = this.querySelectorAll("fieldset");

      if (sourceFieldsets.length > 0 && destFieldsets.length > 0) {
        sourceFieldsets.forEach((sourceFieldset, index) => {
          if (destFieldsets[index]) {
            destFieldsets[index].removeAttribute("data-initialized");
            destFieldsets[index].innerHTML = this.scopeMarkupToSection(
              sourceFieldset.innerHTML,
              currentSectionId,
              sourceSectionId
            );
            if (sourceFieldset.className)
              destFieldsets[index].className = sourceFieldset.className;
          }
        });
      } else {
        this.innerHTML = this.scopeMarkupToSection(
          sourceVariantPicker.innerHTML,
          currentSectionId,
          sourceSectionId
        );
      }
    }

    // =================================================================
    // 4. RESET MASTER FORM REFERENCE FIELD
    // =================================================================
    const productFormInput = this.getProductSectionRoot()?.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    const sourceProductFormInput = html.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    if (productFormInput && sourceProductFormInput) {
      productFormInput.value = sourceProductFormInput.value;
    }

    const sourceProductForms = html.querySelectorAll(
      `#ProductInfo-${sourceSectionId} product-form form[data-type="add-to-cart-form"]`
    );
    const destinationProductForms =
      productSectionRoot?.querySelectorAll(
        `#ProductInfo-${baseSectionId} product-form form[data-type="add-to-cart-form"]`
      ) || [];

    destinationProductForms.forEach((destinationForm, index) => {
      const sourceForm = sourceProductForms[index];
      if (!sourceForm) return;

      const sourceProductForm = sourceForm.closest("product-form");
      const destinationProductForm = destinationForm.closest("product-form");
      if (sourceProductForm && destinationProductForm) {
        destinationProductForm.dataset.hideErrors =
          sourceProductForm.dataset.hideErrors || "false";
        destinationProductForm.hideErrors =
          destinationProductForm.dataset.hideErrors === "true";
      }

      const sourceRecipientWrapper = sourceForm
        .querySelector("recipient-form")
        ?.closest(".customer");
      const destinationRecipientWrapper = destinationForm
        .querySelector("recipient-form")
        ?.closest(".customer");

      if (sourceRecipientWrapper && destinationRecipientWrapper) {
        destinationRecipientWrapper.outerHTML = this.scopeMarkupToSection(
          sourceRecipientWrapper.outerHTML,
          destinationSectionId,
          sourceSectionId
        );
      } else if (sourceRecipientWrapper) {
        const productIdInput =
          destinationForm.querySelector('input[name="id"]');
        const scopedRecipientMarkup = this.scopeMarkupToSection(
          sourceRecipientWrapper.outerHTML,
          destinationSectionId,
          sourceSectionId
        );

        if (productIdInput) {
          productIdInput.insertAdjacentHTML("afterend", scopedRecipientMarkup);
        } else {
          destinationForm.insertAdjacentHTML(
            "afterbegin",
            scopedRecipientMarkup
          );
        }

        const recipientScriptSrc = sourceRecipientWrapper.querySelector(
          'script[src*="recipient-form.js"]'
        )?.src;
        const recipientFormDefined = !!customElements.get("recipient-form");

        if (
          recipientScriptSrc &&
          !recipientFormDefined &&
          !document.querySelector(`script[src="${recipientScriptSrc}"]`)
        ) {
          const recipientScript = document.createElement("script");
          recipientScript.src = recipientScriptSrc;
          recipientScript.defer = true;
          document.head.appendChild(recipientScript);
        }
      } else if (destinationRecipientWrapper) {
        destinationRecipientWrapper.remove();
      }
    });

    // =================================================================
    // FIX FOR PRODUCT HEADLINE/TITLE
    // =================================================================
    const titleDestination = productSectionRoot?.querySelector(
      `#ProductInfo-${baseSectionId} .product__title, #ProductInfo-${baseSectionId} .product-single__title, #ProductInfo-${baseSectionId} h1`
    );
    const titleSource = html.querySelector(
      `#ProductInfo-${sourceSectionId} .product__title, #ProductInfo-${sourceSectionId} .product-single__title, #ProductInfo-${sourceSectionId} h1`
    );

    if (titleSource && titleDestination) {
      titleDestination.innerHTML = titleSource.innerHTML;
    }
    // ================================================================

    // =================================================================
    // FIX FOR PRODUCT DESCRIPTION
    // =================================================================
    const descriptionDestination = productSectionRoot?.querySelector(
      `#ProductInfo-${baseSectionId} .product__description, #ProductInfo-${baseSectionId} .card__description`
    );
    const descriptionSource = html.querySelector(
      `#ProductInfo-${sourceSectionId} .product__description, #ProductInfo-${sourceSectionId} .card__description`
    );

    if (descriptionSource && descriptionDestination) {
      descriptionDestination.innerHTML = descriptionSource.innerHTML;
    }
    // =================================================================

    // price
    const priceDestination = productSectionRoot?.querySelector(
      `#price-${baseSectionId}`
    );
    const priceStickyDestination = productSectionRoot?.querySelector(
      `#price-sticky-${baseSectionId}`
    );
    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }
    if (priceSource && priceStickyDestination) {
      priceStickyDestination.innerHTML = priceSource.innerHTML;
      const priceText = priceStickyDestination.querySelector(".price-text");
      if (priceText) priceText.className = "price-text";
    }

    const productButtonsSource = html.querySelector(
      `[data-id="ProductButtons-${sourceSectionId}"]`
    );
    const productButtonsSelectors = this.getLinkedSectionIds()
      .map((sectionId) => `[data-id="ProductButtons-${sectionId}"]`)
      .join(", ");
    const productButtonsDestinations =
      productSectionRoot && productButtonsSelectors
        ? productSectionRoot.querySelectorAll(productButtonsSelectors)
        : [];

    if (productButtonsSource && productButtonsDestinations.length > 0) {
      productButtonsDestinations.forEach((buttonsWrapper) => {
        const wrapperSectionId =
          buttonsWrapper.dataset.id?.replace(/^ProductButtons-/, "") ||
          destinationSectionId;
        const sourceHasQuantityPricing =
          productButtonsSource.dataset.hasQuantityPricing === "true";
        const destHadQuantityPricing =
          buttonsWrapper.dataset.hasQuantityPricing === "true";

        if (sourceHasQuantityPricing || destHadQuantityPricing) {
          if (sourceHasQuantityPricing) {
            buttonsWrapper.dataset.hasQuantityPricing = "true";
          } else {
            buttonsWrapper.removeAttribute("data-has-quantity-pricing");
          }

          const sourceB2bEl = productButtonsSource.querySelector(
            ".product-b2b-elements"
          );
          const destB2bEl = buttonsWrapper.querySelector(
            ".product-b2b-elements"
          );

          if (sourceB2bEl && destB2bEl) {
            destB2bEl.innerHTML = this.scopeMarkupToSection(
              sourceB2bEl.innerHTML,
              wrapperSectionId,
              sourceSectionId
            );
          } else if (sourceB2bEl && !destB2bEl) {
            buttonsWrapper.insertAdjacentHTML(
              "afterbegin",
              this.scopeMarkupToSection(
                sourceB2bEl.outerHTML,
                wrapperSectionId,
                sourceSectionId
              )
            );
          } else if (!sourceB2bEl && destB2bEl) {
            destB2bEl.remove();
          }

          const sourceQuantityWrapper = productButtonsSource.querySelector(
            ".product-form__quantity"
          );
          const destQuantityWrapper = buttonsWrapper.querySelector(
            ".product-form__quantity"
          );

          if (sourceQuantityWrapper && destQuantityWrapper) {
            destQuantityWrapper.innerHTML = this.scopeMarkupToSection(
              sourceQuantityWrapper.innerHTML,
              wrapperSectionId,
              sourceSectionId
            );
          }
        }
      });
    }

    const floatedInfoSource = html.getElementById(
      `FloatedProductInfo-${sourceSectionId}`
    );
    const floatedInfoDestination = productSectionRoot?.querySelector(
      `#FloatedProductInfo-${baseSectionId}`
    );

    if (floatedInfoSource && floatedInfoDestination) {
      const floatedSummarySource = floatedInfoSource.querySelector(
        "[data-floated-product-summary]"
      );
      const floatedSummaryDestination = floatedInfoDestination.querySelector(
        "[data-floated-product-summary]"
      );

      if (floatedSummarySource && floatedSummaryDestination) {
        floatedSummaryDestination.innerHTML = floatedSummarySource.innerHTML;
      }

      const floatedFormSource = floatedInfoSource.querySelector("floated-form");
      const floatedFormDestination =
        floatedInfoDestination.querySelector("floated-form");

      if (floatedFormSource && floatedFormDestination) {
        floatedFormDestination.dataset.productUrl =
          floatedFormSource.dataset.productUrl || "";
      }
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = productSectionRoot?.querySelector(
      `#Inventory-${baseSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }

    const pickerInventorySource = html.getElementById(
      `PickerInventory-${sourceSectionId}`
    );
    const pickerInventoryDestination = productSectionRoot?.querySelector(
      `#PickerInventory-${baseSectionId}`
    );
    if (pickerInventorySource && pickerInventoryDestination) {
      pickerInventoryDestination.innerHTML = pickerInventorySource.innerHTML;
      pickerInventoryDestination.classList.toggle(
        "visibility-hidden",
        pickerInventorySource.innerText === ""
      );
    }

    // sku
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = productSectionRoot?.querySelector(
      `#Sku-${baseSectionId}`
    );
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = productSectionRoot
      ? productSectionRoot.querySelectorAll(
          `[id^="ColorName-${baseSectionId}"]`
        )
      : [];
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const variantSwatchesSource = html.querySelector(
        `#variant-picker-${sourceSectionId} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = document.querySelector(
        `#variant-picker-${currentSectionId} [data-is-variant-image-swatch="true"]`
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        const quickViewModal = this.closest("quick-add-modal");
        if (quickViewModal) {
          variantSwatchesDestination.innerHTML = this.scopeMarkupToSection(
            variantSwatchesSource.innerHTML,
            currentSectionId,
            sourceSectionId
          );
        } else {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML;
        }

        this.removeDuplicateImageSwatches();
      }
    }

    // product media
    if (
      this.dataset?.variantMediaDisplay !== "show_all" ||
      this.isCombinedListingsNeedUpdate
    ) {
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination =
        productSectionRoot?.querySelector(
          `[data-section="product-media-${destinationSectionId}"]`
        ) ||
        (!isQuickView
          ? document.querySelector(
              `[data-section="product-media-${baseSectionId}"]`
            )
          : null);
      if (mediaSource && mediaDestination) {
        // 1. SAFELY CLEAN UP MEMORY FOR PREVIOUS SWIPER INSTANCES BEFORE OVERWRITING HTML
        const oldMainSwiper =
          mediaDestination.querySelector(".js-media-list")?.swiper;
        const oldSubSwiper =
          mediaDestination.querySelector(".js-media-sublist")?.swiper;

        if (oldMainSwiper) oldMainSwiper.destroy(true, true);
        if (oldSubSwiper) oldSubSwiper.destroy(true, true);

        // 2. DROP IN NEW MARKUP
        mediaDestination.innerHTML = mediaSource.innerHTML;

        const parentQuickView = this.closest("quick-add-modal");
        const parentFeaturedProduct = this.closest(".featured-product-section");
        const section = document.getElementById(
          `shopify-section-${baseSectionId}`
        );

        if (parentQuickView) {
          if (typeof parentQuickView.reinitMedia === "function") {
            parentQuickView.reinitMedia();
          }
        } else if (parentFeaturedProduct) {
          if (typeof subSliderInit === "function") {
            subSliderInit(true);
          }
          if (typeof sliderInit === "function") {
            sliderInit(true);
          }
          if (section && typeof window.initFeaturedProduct === "function") {
            window.initFeaturedProduct(section);
          }
        } else {
          if (typeof subSliderInit === "function") {
            subSliderInit(true);
          }
          if (typeof sliderInit === "function") {
            sliderInit(true);
          }
          if (section && typeof initProductPage === "function") {
            initProductPage(section);
          }
        }

        // =================================================================
        // THE HARD 'CTRL + Z' SIMULATION: PHYSICAL ELEMENT RE-MOUNTING
        // =================================================================
        if (!parentQuickView) {
          window.setTimeout(() => {
            // Reinitialize standard theme components
            const components = mediaDestination.querySelectorAll(
              "product-modal, media-gallery, product-media, deferred-media"
            );
            components.forEach((el) => {
              if (typeof el.init === "function") el.init();
              if (typeof el.setupListeners === "function") el.setupListeners();
            });

            if (
              window.theme &&
              typeof window.theme.initProductMedias === "function" &&
              section
            ) {
              window.theme.initProductMedias(section);
            }

            // Force a full DOM detachment on the toggle buttons and wrappers
            const elementsToReset = mediaDestination.querySelectorAll(
              ".product__media, .product__media-toggle"
            );
            elementsToReset.forEach((el) => {
              const parent = el.parentNode;
              const nextSibling = el.nextSibling;

              if (parent) {
                // 1. Physically delete it from the live DOM tree
                parent.removeChild(el);

                // 2. Insert it back immediately, breaking the browser cache loop
                if (nextSibling) {
                  parent.insertBefore(el, nextSibling);
                } else {
                  parent.appendChild(el);
                }
              }
            });
          }, 50);
        }
      }

      // Product modal sync
      const modalSource = html.getElementById(
        `ProductModal-${sourceSectionId}`
      );
      const modalDestination =
        productSectionRoot?.querySelector(
          `#ProductModal-${destinationSectionId}`
        ) ||
        (!isQuickView
          ? document.querySelector(`#ProductModal-${baseSectionId}`)
          : null);
      if (modalSource && modalDestination) {
        modalDestination.innerHTML = modalSource.innerHTML;
        this.reinitModalSwiper(modalDestination);

        // =================================================================
        // HARD DETACH AND RESET INSIDE THE ZOOM MODAL OVERLAY
        // =================================================================
        window.setTimeout(() => {
          if (typeof modalDestination.setupListeners === "function") {
            modalDestination.setupListeners();
          }

          // Hard detach all zoom slides inside the modal container to fix the inner zoom freeze
          const modalSlides = modalDestination.querySelectorAll(
            ".swiper-slide, .swiper-zoom-container, img"
          );
          modalSlides.forEach((slide) => {
            const parent = slide.parentNode;
            const next = slide.nextSibling;
            if (parent) {
              parent.removeChild(slide);
              if (next) parent.insertBefore(slide, next);
              else parent.appendChild(slide);
            }
          });

          const closeButtons = modalDestination.querySelectorAll(
            '[id^="ModalClose-"], .product-popup-modal__toggle, .modal__toggle, .close-button'
          );

          closeButtons.forEach((btn) => {
            btn.removeAttribute("disabled");
            btn.removeAttribute("aria-disabled");
            btn.style.setProperty("pointer-events", "auto", "important");
            btn.style.setProperty("cursor", "pointer", "important");
            btn.style.setProperty("z-index", "99999", "important");

            btn.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              if (typeof modalDestination.hide === "function") {
                modalDestination.hide();
              } else if (typeof modalDestination.close === "function") {
                modalDestination.close();
              } else {
                const openModalContainer = btn.closest(
                  "product-modal, .product-media-modal, dialog"
                );
                if (openModalContainer) {
                  if (typeof openModalContainer.hide === "function")
                    openModalContainer.hide();
                  else openModalContainer.style.display = "none";
                }
                document.body.classList.remove("overflow-hidden");
              }
            });
          });
        }, 120);
        window.setTimeout(() => {
          const components = mediaDestination.querySelectorAll(
            "product-modal, media-gallery, product-media, deferred-media"
          );
          components.forEach((el) => {
            if (typeof el.init === "function") el.init();
            if (typeof el.setupListeners === "function") el.setupListeners();
          });

          if (
            window.theme &&
            typeof window.theme.initProductMedias === "function" &&
            section
          ) {
            window.theme.initProductMedias(section);
          }

          // Add this line right here to attach the cross icon to the newly downloaded image nodes:
          if (typeof window.reinitProductUI === "function") {
            window.reinitProductUI();
          }
        }, 120);
      }
    }
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.getBaseSectionId();

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestionation = document.getElementById(
      `variant-picker-${this.dataset.section}`
    );
    if (!variantPickerSource) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestionation.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.getBaseSectionId();

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-picker-${currentSectionId}`
    );

    if (variantPickerSource && variantPickerDestination) {
      const quickViewModal = this.closest("quick-add-modal");
      if (quickViewModal) {
        variantPickerDestination.innerHTML = this.scopeMarkupToSection(
          variantPickerSource.innerHTML,
          currentSectionId,
          sourceSectionId
        );
      } else {
        variantPickerDestination.innerHTML = this.scopeMarkupToSection(
          variantPickerSource.innerHTML,
          currentSectionId,
          sourceSectionId
        );
      }

      this.removeDuplicateImageSwatches(variantPickerDestination);
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
        input.disabled = false;
      } else {
        input.classList.add("disabled");
        //input.disabled = true;
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll(".field--pass");

    passwordField.forEach((el) => {
      const input = el.querySelector("input");
      const btnWrapper = el.querySelector(".button-pass-visibility");
      const btnOpen = el.querySelector(".icon-eye-close");
      const btnClose = el.querySelector(".icon-eye");

      input.addEventListener("input", () => {
        input.value !== ""
          ? (btnWrapper.style.display = "block")
          : (btnWrapper.style.display = "none");
      });

      btnOpen.addEventListener("click", () => {
        input.type = "text";
        btnOpen.style.display = "none";
        btnClose.style.display = "block";
      });

      btnClose.addEventListener("click", () => {
        input.type = "password";
        btnOpen.style.display = "block";
        btnClose.style.display = "none";
      });
    });
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          /* Color swatches */
          const generateSrcset = (image, widths = []) => {
            const imageUrl = new URL(image["src"]);
            return widths
              .filter((width) => width <= image["width"])
              .map((width) => {
                imageUrl.searchParams.set("width", width.toString());
                return `${imageUrl.href} ${width}w`;
              })
              .join(", ");
          };

          const createImageElement = (image, classes, sizes, productTitle) => {
            const previewImage = image["preview_image"];
            const newImage = new Image(
              previewImage["width"],
              previewImage["height"]
            );
            newImage.className = classes;
            newImage.alt = image["alt"] || productTitle;
            newImage.sizes = sizes;
            newImage.src = previewImage["src"];
            newImage.srcset = generateSrcset(
              previewImage,
              [165, 360, 533, 720, 940, 1066]
            );
            newImage.loading = "lazy";
            return newImage;
          };

          const checkSwatches = () => {
            document
              .querySelectorAll(".js-color-swatches-wrapper")
              .forEach((wrapper) => {
                wrapper
                  .querySelectorAll(".js-color-swatches input")
                  .forEach((input) => {
                    input.addEventListener("click", (event) => {
                      const primaryImage =
                        wrapper.querySelector(".media--first");
                      const secondaryImage =
                        wrapper.querySelector(".media--second");
                      const handleProduct = wrapper.dataset.product;

                      if (event.currentTarget.checked && primaryImage) {
                        wrapper
                          .querySelector(".js-color-swatches-link")
                          .setAttribute(
                            "href",
                            event.currentTarget.dataset.variantLink
                          );
                        if (
                          wrapper.querySelector(
                            '.card__add-to-cart button[name="add"]'
                          )
                        ) {
                          wrapper
                            .querySelector(
                              '.card__add-to-cart button[name="add"]'
                            )
                            .setAttribute("aria-disabled", false);
                          if (
                            wrapper.querySelector(
                              '.card__add-to-cart button[name="add"] > span'
                            )
                          ) {
                            wrapper
                              .querySelector(
                                '.card__add-to-cart button[name="add"] > span'
                              )
                              .classList.remove("hidden");
                            wrapper
                              .querySelector(
                                '.card__add-to-cart button[name="add"] .sold-out-message'
                              )
                              .classList.add("hidden");
                          }
                          wrapper.querySelector(
                            '.card__add-to-cart input[name="id"]'
                          ).value = event.currentTarget.dataset.variantId;
                        }
                        const currentColor = event.currentTarget.value;

                        jQuery.getJSON(
                          window.Shopify.routes.root +
                            `products/${handleProduct}.js`,
                          function (product) {
                            const variant = product.variants.filter(
                              (item) =>
                                item.featured_media != null &&
                                item.options.includes(currentColor)
                            )[0];

                            if (variant) {
                              const newPrimaryImage = createImageElement(
                                variant["featured_media"],
                                primaryImage.className,
                                primaryImage.sizes,
                                product.title
                              );

                              if (newPrimaryImage.src !== primaryImage.src) {
                                let flag = false;
                                if (secondaryImage) {
                                  const secondaryImagePathname = new URL(
                                    secondaryImage.src
                                  ).pathname;
                                  const newPrimaryImagePathname = new URL(
                                    newPrimaryImage.src
                                  ).pathname;

                                  if (
                                    secondaryImagePathname ==
                                    newPrimaryImagePathname
                                  ) {
                                    primaryImage.remove();
                                    secondaryImage.classList.remove(
                                      "media--second"
                                    );
                                    secondaryImage.classList.add(
                                      "media--first"
                                    );
                                    flag = true;
                                  }
                                }
                                if (flag == false) {
                                  primaryImage.animate(
                                    { opacity: [1, 0] },
                                    {
                                      duration: 200,
                                      easing: "ease-in",
                                      fill: "forwards",
                                    }
                                  ).finished;
                                  setTimeout(function () {
                                    primaryImage.replaceWith(newPrimaryImage);
                                    newPrimaryImage.animate(
                                      { opacity: [0, 1] },
                                      { duration: 200, easing: "ease-in" }
                                    );
                                    if (secondaryImage) {
                                      secondaryImage.remove();
                                    }
                                  }, 200);
                                }
                              }
                            }
                          }
                        );
                      }
                    });
                  });
              });
          };

          checkSwatches();

          const calcTop = (section) => {
            const imageWrapper = section.querySelectorAll(".card__inner");
            let top = 0;

            if (imageWrapper) {
              top = imageWrapper[0].offsetHeight / 2;
            } else {
              top = 50;
            }

            return top;
          };

          const initSlider = () => {
            document
              .querySelectorAll(".js-recommendation-swiper")
              .forEach((elem, index) => {
                let mobileLayout = 1;
                if (elem.dataset.mobileLayout) {
                  mobileLayout = elem.dataset.mobileLayout;
                }
                let slider = new Swiper(elem, {
                  slidesPerView: mobileLayout,
                  slidesPerGroup: 1,
                  spaceBetween: 12,
                  speed: 1000,
                  navigation: {
                    nextEl: elem.querySelector(
                      ".product-recommendations__slider-nav .swiper-button-next"
                    ),
                    prevEl: elem.querySelector(
                      ".product-recommendations__slider-nav .swiper-button-prev"
                    ),
                  },
                  breakpoints: {
                    576: {
                      slidesPerView: 2,
                      slidesPerGroup: 2,
                    },
                    750: {
                      spaceBetween: 16,
                      slidesPerView: 3,
                      slidesPerGroup: 3,
                    },
                    1200: {
                      spaceBetween: 16,
                      slidesPerView: 5,
                      slidesPerGroup: 5,
                    },
                    1600: {
                      spaceBetween: 16,
                      slidesPerView: 6,
                      slidesPerGroup: 6,
                    },
                  },
                });
              });
          };

          const initSection = () => {
            const section = this;

            const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
              let top = calcTop(section);
              if (section.querySelector(".product-recommendations__slider-nav"))
                section.querySelector(
                  ".product-recommendations__slider-nav"
                ).style.top = top + "px";
            });

            sectionResizeObserver.observe(section);

            initSlider();
          };

          initSection();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);
(function () {
  const initHeaderOverlay = () => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector(
        ".section--has-overlay"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );
      const header = document.querySelector(".shopify-section-header");

      if (sectionFirstChild) {
        if (sectionFirstChild.classList.contains("section--has-overlay")) {
          if (headerGroupSections[headerGroupSections.length - 1] === header) {
            sections[0].classList.remove("not-margin");
            header.classList.add("color-background-1", "color-background-3");
          } else {
            sections[0].classList.add("not-margin");
            header.classList.remove("color-background-1", "color-background-3");
          }
        } else {
          sections[0].classList.remove("not-margin");
          header.classList.remove("color-background-1", "color-background-3");
        }
      }
    }
  };

  initHeaderOverlay();

  document.addEventListener("shopify:section:load", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:unload", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:reorder", function () {
    initHeaderOverlay();
  });
})();

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  cents = parseInt(cents, 10);

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousands}`
    );

    const centsAmount = precision > 0 ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  const formatType = match ? match[1] : "amount";

  switch (formatType) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
}

(function () {
  const selectDropDown = () => {
    // Only target dropdowns that haven't been initialized yet
    const dropdowns = document.querySelectorAll(
      ".product-form__controls--dropdown:not([data-initialized])"
    );

    dropdowns.forEach((container) => {
      const elList = container.querySelector(".dropdown-select ul");
      const elListItems = container.querySelectorAll(".dropdown-select ul li");
      const selectedText = container.querySelector(
        ".dropdown-select .select-label"
      );
      const shadowTop = container.querySelector(".shadow-top");
      const shadowBottom = container.querySelector(".shadow-bottom");

      if (!elList || !selectedText) return;

      container.setAttribute("data-initialized", "true");

      const updateShadows = () => {
        shadowTop?.classList.toggle("show", elList.scrollTop > 0);
        shadowBottom?.classList.toggle(
          "show",
          elList.scrollTop + elList.clientHeight < elList.scrollHeight - 5
        );
      };

      selectedText.addEventListener("click", function (e) {
        e.stopPropagation();
        const isActive = elList.classList.contains("active");

        // Close other open dropdowns
        document
          .querySelectorAll(".dropdown-select ul.active")
          .forEach((openUl) => {
            if (openUl !== elList) openUl.classList.remove("active");
          });

        elList.classList.toggle("active");
        if (elList.classList.contains("active")) updateShadows();
      });

      elListItems.forEach((li) => {
        li.addEventListener("click", function () {
          const input = li.querySelector("input");
          const isNotifyMe = li
            .querySelector(".pills-variant-labels")
            ?.classList.contains("notify_me");

          if ((input && !input.classList.contains("disabled")) || isNotifyMe) {
            const span = selectedText.querySelector("span");
            if (span) {
              span.textContent = li.innerText.trim();
              span.setAttribute("title", li.innerText.trim());
            }
            if (li.dataset.color) {
              selectedText.style.setProperty(
                "--swatch-color",
                li.dataset.color
              );
            }
          }
          elList.classList.remove("active");
        });
      });

      elList.addEventListener("scroll", updateShadows);
    });
  };

  // 1. Initial Load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", selectDropDown);
  } else {
    selectDropDown();
  }

  // 2. Global click to close
  document.addEventListener("click", () => {
    document
      .querySelectorAll(".dropdown-select ul.active")
      .forEach((ul) => ul.classList.remove("active"));
  });

  // 3. Shopify Theme Editor Support
  document.addEventListener("shopify:section:load", selectDropDown);

  // 4. THE FIX: Watch for AJAX/Internal page refreshes
  // This observes the body for any added elements and re-runs the init logic
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        selectDropDown();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".cart-items-wrapper" },
    { id: "main-cart-footer", selector: ".cart__footer" },
    { id: "main-cart-shipping", selector: ".cart-shipping" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});

// CART REFRESH EVENT END
// -----------------------------------------------------------------------------
